import React from "react";
import { Modal } from "antd";
import "./style.css";

const GenericModal = ({
  title,
  open,
  onOk,
  onCancel,
  footer,
  children,
  okText = "OK",
  cancelText = "Cancel",
  cancelStyle = false,
  okButtonProps,
}) => {
  return (
    <Modal
      className={`generic-modal ${cancelStyle ? "cancel-style" : ""}`}
      title={title}
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      footer={footer}
      okText={okText}
      cancelText={cancelText}
      okButtonProps={okButtonProps}
      centered
    >
      {children}
    </Modal>
  );
};

export default GenericModal;
